"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IHttpRequestResult = void 0;
var IHttpRequestResult = /** @class */ (function () {
    function IHttpRequestResult() {
    }
    return IHttpRequestResult;
}());
exports.IHttpRequestResult = IHttpRequestResult;
//# sourceMappingURL=http.models.js.map